'use client'
import { FC, PropsWithChildren } from 'react'
import { SplideTrack } from '@splidejs/react-splide'

export const CarouselTrack: FC<PropsWithChildren> = ({ children }) => (
  <SplideTrack className="!pr-0">{children}</SplideTrack>
)
